import classNames from 'classnames';
import { FC, useCallback, useState } from 'react';
import AnimateHeight from 'react-animate-height';

import IconExpand from '../../static/images/icons/icon-expand.svg';
import IconCollapse from '../../static/images/icons/icon-collapse.svg';

import styles from './CollapsibleListItem.module.scss';

interface Props {
  content: string | React.ReactNode;
  headerVariant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p';
  isExpanded?: boolean;
  title: string;
}

const CollapsibleListItem: FC<Props> = ({
  content,
  isExpanded = false,
  title,
  headerVariant = 'p',
}) => {
  const [isOpen, setOpen] = useState(isExpanded);

  const handleToggle = useCallback(() => {
    setOpen((value) => !value);
  }, []);

  const height = isOpen ? 'auto' : 0;
  const TitleTag = headerVariant;

  return (
    <>
      <button
        className={classNames(styles['title'], {
          [styles['title-border_collapse']]: isOpen,
        })}
        onClick={handleToggle}
      >
        <TitleTag>{title}</TitleTag>
        {isOpen ? (
          <IconCollapse className={styles['svg']} />
        ) : (
          <IconExpand className={styles['svg']} />
        )}
      </button>

      <AnimateHeight duration={300} height={height}>
        <p className={styles['content']}>{content}</p>
      </AnimateHeight>
    </>
  );
};

export default CollapsibleListItem;
export type { Props as CollapsibleListItemProps };
